/*
    2019-11-04
    曹秀芳
    制作EquipmentUtilizationRate页面
*/ 
<template>
  <div class="EquipmentUtilizationRate mainWrap"><!--需要修添加class-->
    <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);">
      <!-- 左边导航栏 -->
      <el-aside style="width:auto;">
        <leftNav msg="/EquipmentUtilizationRate"></leftNav><!--改组件名-->
      </el-aside>
      <!-- 右侧主体部分 -->
      <el-scrollbar class="machineWrap" style="height:100%;width:100%;" v-loading='ReportLoading'>
        <a download=""></a>
        <el-main>
          <div class="mainWrao">
            <div class="recordTitle">
              <h1>{{$t('leftNav.navTwentyTwo')}}</h1>
              <div class="machineSeach">
                <label style="margin-right:10px;font-size:12px;">{{$t('EquipmentUtilizationRate.righttitle')}}:</label>
                <!-- <el-cascader
                  class="idStyle"
                  @change="getShiftTime()"
                  :placeholder="$t('SingleTireStepAnalysis.placehoder1')"
                  expand-trigger="hover"
                  :options="options"
                  filterable
                  v-model="machineID">
                </el-cascader> -->
                <ul style="display:flex;">
                  <li v-for="item in options" :key="item.value" class="everyWorkShop" :class="{'activeWorkShop':item.value == onevalue}" @click="getShiftTime(item)">
                    {{item.label}}
                  </li>
                </ul>
              </div>
            </div>
            <!-- 页面主体部分-->
            <div class="my">
              <div class="FailureTime-body">
                <!-- 下载按钮 -->
                <div style="height: 66px;">
                  <div class="downBotton">
                    <el-row>
                      <el-button size="small" @click="isExportShow"><downloadIcon style="font-size:14px;" title=""/> {{$t('EventRecord.Export')}}</el-button>
                      <!-- 弹框 -->
                      <el-dialog width="936px" center title="" @open="getFileName()" :visible.sync="dialogTableVisible">
                        <div class="ElasticTitle">{{$t('EquipmentUtilizationRate.SelectExportData')}}</div>
                        <div class="myBody" v-loading='alertLoading'>
                            <div class="myLeft">
                                <div>
                                  <div :class="{'yearMonths':true,'yearMonths-right':!$store.state.lang}">
                                      <div class="yearMonths-box">
                                      <el-date-picker
                                          v-model="monthValue"
                                          type="month"
                                          :placeholder="$t('AnalogValueAnalysis.Choosedate')"
                                          :picker-options="pickerOptions">
                                      </el-date-picker>
                                      </div>
                                  </div>
                                  <div class="nextMonth" v-show="nextMonthNone && $store.state.lang">下个月</div>
                                  <div class="nextMonth" v-show="nextMonthNone && !$store.state.lang">Next Month</div>
                                </div>
                                <div>
                                    <el-calendar v-model="monthValue">
                                    </el-calendar>
                                </div>
                            </div>
                            <div class="myRight">
                                <div class="rightTitle">{{$t('DetailedStepReport.weeklyReport')}}</div>
                                <ul class="rightBody">
                                    <li class="rightItem" v-for="(item,index) in fileName" :key="index">
                                      <div class="rightLine"></div>
                                      <div :class="{'rightCircular':true,'rightCircularColor':fileName[index].isBoolean === false}" @click="exportExcel(index,fileName[index].isBoolean)">
                                          <BriefcaseDownload  title="" class="BriefcaseDownload"/>
                                          <p v-show="!fileName[index].isBoolean" class="fileName">{{$t('DetailedStepReport.NoData')}}</p>
                                          <p v-show="fileName[index].isBoolean" class="fileName">{{fileName[index].fileName}}</p>
                                      </div>
                                    </li>
                                </ul>
                            </div>
                        </div> 
                      </el-dialog> 
                    </el-row>
                  </div>
                </div>
                <!-- 页面表格 -->
                <div style="background:#fff;" :class="{'widthOne':widthBoo,'widthTwo':!widthBoo}">
                  <el-table
                    :data="tableData"
                    style="width: 100%"
                    height="498"
                    :empty-text="$t('WorkShopDashBoard.noEquipmentTableMessage')"
                    ref="table">
                    <el-table-column
                      fixed
                      prop="start"
                      width="290">
                        <el-table-column
                          align="center"
                          prop="start"
                          :label="$t('FailureTimeStatistics.date')"
                          width="110">
                          <template slot-scope="scope">
                            <span>{{scope.row.start | formatDate}}</span>
                          </template>
                        </el-table-column>
                        <el-table-column
                          align="center"
                          prop="start"
                          :label="$t('FailureTimeStatistics.StartTime')"
                          width="90">
                          <template slot-scope="scope">
                            <span>{{scope.row.start | formatTime}}</span>
                          </template>
                        </el-table-column>
                        <el-table-column
                          align="center"
                          prop="start"
                          :label="$t('FailureTimeStatistics.EndTime')"
                          width="90">
                          <template slot-scope="scope">
                            <span>{{scope.row.end | formatTime}}</span>
                          </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column
                      v-for="item in tabletitle"
                      :key="item.label"
                      :prop="item.prop"
                      :label="item.label"
                      align="center">
                          <el-table-column
                          align="center"
                          :label="$t('EquipmentUtilizationRate.ShiftInformation')"
                          width="140">
                            <template slot-scope="scope">
                              <el-popover trigger="hover" placement="top">
                                <p v-if="scope.row.failureTimeLogList[item.prop][0] !== null && scope.row.failureTimeLogList[item.prop][0].state === 1">{{$t('EquipmentUtilizationRate.ShiftProduction')}}</p>
                                <p v-if="scope.row.failureTimeLogList[item.prop][0] !== null && scope.row.failureTimeLogList[item.prop][0].state === 2">{{$t('EquipmentUtilizationRate.TimeLossDueToFailure')}}</p>
                                <p v-if="scope.row.failureTimeLogList[item.prop][0] !== null && scope.row.failureTimeLogList[item.prop][0].state === 3">{{$t('EquipmentUtilizationRate.TimeLossDueToReloading')}}</p>
                                <div slot="reference" class="name-wrapper">
                                  <div v-if="scope.row.failureTimeLogList[item.prop][0] !== null">{{ scope.row.failureTimeLogList[item.prop][0].value}}</div>
                                </div>
                              </el-popover>
                            </template>
                          </el-table-column>
                          <el-table-column
                            align="center"
                            :label="$t('EquipmentUtilizationRate.Production')"
                            width="100">
                              <template slot-scope="scope">
                                <span>{{scope.row.failureTimeLogList[item.prop][1]}}</span>
                              </template>
                          </el-table-column>
                          <el-table-column
                            align="center"
                            :label="$t('EquipmentUtilizationRate.FailureEffectiveTime')"
                            width="170">
                              <template slot-scope="scope">
                                <span>{{scope.row.failureTimeLogList[item.prop][2]+"'"}}</span>
                              </template>
                          </el-table-column>
                          <el-table-column
                            align="center"
                            :label="$t('EquipmentUtilizationRate.TimeOfReloading')"
                            
                            >
                              <template slot-scope="scope">
                                <span>{{scope.row.failureTimeLogList[item.prop][3]+"'"}}</span>
                              </template>
                          </el-table-column> 
                    </el-table-column>
                </el-table>
                </div> 
              </div>
              <footer class="footer" >
                <div class="footer-el" v-if="!noMachine">
                  <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="200"
                    :current-page.sync="nowPage"
                    @current-change="handleCurrentChange"
                    @size-change="handleCurrentSizeChange"
                  >
                  </el-pagination>
                </div>
              </footer>
            </div>
          </div>
        </el-main>
      </el-scrollbar>
    </el-container>
  </div>
</template>
<script>
import leftNav from "@/components/nav.vue"
import downloadIcon from "vue-material-design-icons/Download.vue"
import BriefcaseDownload from "vue-material-design-icons/BriefcaseDownload.vue"
//引入转换时间文件
import { formatDate } from '../assets/js/date.js'

let timer = new Date();
timer.setDate(1)
export default {
  name: 'PF001',
  components: {
    leftNav,
    downloadIcon,
    BriefcaseDownload
  },
  data () {
    return {
      //  模拟数据
      options: [],
      // 选中的机械id
      machineID: [],
      // 选中的工厂id
      factoryId:'',
      fullscreenLoading: false,
      //我的代码
      tabletitle:[],
      tableData: [],
      // 局部刷新
      ReportLoading: false,
      // 当前页数
      nowPage: 1,
      nowPageSize: 24,
      widthBoo:true,

      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      fileName:[{isBoolean:false},{isBoolean:false},{isBoolean:false},{isBoolean:false},{isBoolean:false},{isBoolean:false}],
      dialogTableVisible: false,
      monthValue:timer,
      nextMonthNone:true,
      // 工厂id
      shopId:null,
      alertLoading:false,
      // 默认选中的车间
      onevalue:'',
      noMachine:true
    }
  },
  computed: {
    islangChange () {
      return this.$store.state.lang
    }
  },
  watch: {
    islangChange (curval, oldval) {
      if (curval != oldval) {
        this.$parent.reload()
      }
    },
    machineID(){
      this.monthValue = timer//当选中的机器发生变化时，日历重置
    },
    monthValue(){
      //下个月禁用状态
      if(this.monthValue === null){
        this.nextMonthNone = true
        return
      }
      let year = new Date().getFullYear()//此刻的年份
      let mon = new Date().getMonth()+1//此刻的月份
      let nowYaer = this.monthValue.getFullYear()//选择的年份
      let nowMon = this.monthValue.getMonth()+1//选择的月份
      if(nowMon >= mon && nowYaer>= year){
          this.nextMonthNone = true
      }else{
          this.nextMonthNone = false
      }
      this.getFileName()
    }
  },
  mounted() {
    this.ReportLoading = true
    this.$store.commit('authority' , this.$route.path)
    this.factoryId = this.$store.state.defaultFactoryId
    this.shopId = localStorage.getItem('defaultShopId');
    this.getShopList()
  },
  destroyed() {
  },
  methods: {
    // 获取车间列表
    getShopList() {
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/selectChooseShop',
        params:{
          language: _this.$store.state.lang,
          shopId: _this.shopId
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          if(res.data.options !==undefined && res.data.options.length > 0 ){
             _this.noMachine=false
            if (res.data.belong === 1) {
              res.data.options.forEach(item=>{
                // if(item.value == _this.shopId){
                //   _this.machineID = [item.value, item.children[0].value]
                // }
                _this.machineID = [item.value, item.children[0].value]
              })
              _this.options = res.data.options[0].children
              //让默认选中的车间与登录返回的默认车间保持一致
              // _this.onevalue = _this.options[0].value
              _this.onevalue = _this.$store.state.defaultShopId
              _this.ReportTable()
            } else{
              _this.$router.push({path: '/login', name: 'login'})
            }
          }else{
            _this.ReportLoading = false
            _this.noMachine=true
            _this.options = res.data.options
            _this.$message(_this.$t('Dailyequipment.noEquipmentData'));
            _this.$store.commit('loginOut')
            _this.$router.replace({
                path: '/login'
            })
          }
        } else {
          _this.$message.error('Machine list loading failed')
        }
      })
      
    },
    //我的代码
    // 请求表格的数据
    ReportTable(){
      let _this = this
      _this.tabletitle=[]
      _this.tableData=[]
      this.ReportLoading = true
       this.axios({
        method: 'get',
        url: '/url/getUtilizationRate',
        params:{
          language: _this.$store.state.lang,
          shopId: _this.shopId,
          pageSize:_this.nowPageSize,
          pageNum:_this.nowPage
        }
      }).then(function(res){
        if(JSON.stringify(res.data) == "{}"){
          _this.noMachine=true
        }else{
          _this.noMachine=false
          _this.tabletitle = res.data.tableTitle
          _this.tableData = res.data.leftTitle
          if(res.data.tableTitle.length === 1){
            _this.widthBoo = false
          }else{
            _this.widthBoo = true
          }
        }
      }).then(function(){
        setTimeout(() => {
            _this.$nextTick(() => {
              _this.$refs.table.doLayout()
            })
        }, 300)
        _this.ReportLoading = false
      }).catch(function(){
        _this.ReportLoading = false
      })
    },
    //当选中的工厂和机器发生改变时
    getShiftTime(item){
      this.onevalue=item.value
      this.machineID[1]=item.value
      this.nowPage = 1
      this.shopId = this.machineID[1]
      this.ReportTable()
    },
    // 分页
    handleCurrentChange (val) {
      this.nowPage = val
      this.getEventRecordListPage()
    },
    getEventRecordListPage () { 
      this.loading = true
      //调用请求表格的数据
      this.ReportTable()
    },
    handleCurrentSizeChange (val) {
      this.nowPageSize = val
      this.getEventRecordList()
    },
    isExportShow(){
      if(this.tableData == null || this.tableData.length == 0){
        this.$message.error(this.$t('gantt.error'));
      }else{
        this.dialogTableVisible = true
      }
    },
    // 导出功能
    exportExcel(i,j){
      if(!this.machineID[1]){
        this.$message.error(this.$t('AnalogValueAnalysis.equipment'));
      }else{
        if(j === false){//如果下载按钮为灰色
          return
        }
        if(this.monthValue === null){
          return
        }
        let dateNum = this.monthValue.getDate()
        let monthVal = this.monthValue

        if(monthVal.getDate()!==1){
          let clickMonth = this.monthValue
          clickMonth.setDate(1)
          monthVal = clickMonth
        }
        let x = i

        let weekStart = monthVal.getDay()
        let y = monthVal.getFullYear()
        let m = monthVal.getMonth()+1
        if(weekStart === 0){
          weekStart = 7
        }
        let d = monthVal.getDate()-weekStart+1
            d = d+x*7

            if(d<1){
              if(m==2 || m==4 || m==6 || m==8 || m==9 || m==11 || m==1){
                d = d+31
              }else if(m==5 || m==7 || m==10 || m==12){
                d = d+30
              }else if(m==3){
                let Leap = ''+y/4
                if(Leap.length>3){
                  d = d+28
                }else{
                  d = d+29
                }
              }
              m = m-1
              if(m<1){
                m = 12
                y = y-1
              }
            }

            let Leap = ''+y/4
            if(Leap.length>3){//闰年
              if(m==2){
                if(d>29){
                  m = m+1
                  d=d-29
                }
              }else if(m==4 || m==6 || m==9 || m==11){
                if(d>30){
                  m = m+1
                  d=d-30
                }
              }else{
                if(d>31){
                  m = m+1
                  d=d-31
                }
              }
            }else{
              if(m==2){
                if(d>28){
                  m = m+1
                  d=d-28
                }
              }else if(m==4 || m==6 || m==9 || m==11){
                if(d>30){
                  m = m+1
                  d=d-30
                }
              }else{
                if(d>31){
                  m = m+1
                  d=d-31
                }
              }
            }
        let dataTime = y +'-'+ m +'-'+ d +' 07:40:00'
        
        let signTime = new Date().getTime()
        this.$store.commit('nowsign', signTime)
        let urlData = '?shopId=' + this.machineID[1] + '&dateTime=' + dataTime + '&language='+ this.$store.state.lang + '&sign='+this.$store.state.sign + '&auth_Code='+this.$store.state.authCode+'&sign_time='+signTime +'&route='+this.$store.state.newroute+'&factory_id='+this.$store.state.factoryId
          
        window.open('/download/getUtilizationRateExportLog' + urlData, '_blank')

        let todayDate = this.monthValue
        todayDate.setDate(dateNum)

      }
    },

// ---------弹框--------------
    getFileName(){//获取文件名及下载按钮的颜色
      this.fileName=[{isBoolean:false},{isBoolean:false},{isBoolean:false},{isBoolean:false},{isBoolean:false},{isBoolean:false}]
      
      let y = this.monthValue.getFullYear()
      let m = this.monthValue.getMonth()+1
      if(m<10){
        m = '0'+m
      }
      let timeValue = y+'-'+m+'-01 08:00:00'

      let _this = this
      this.alertLoading = true
      this.axios({
        method: 'get',
        url: '/url/getUtilizationRateButton',
        params:{
          language: _this.$store.state.lang,
          shopId: _this.shopId,
          time:timeValue
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          _this.fileName = res.data.list
          _this.alertLoading = false
        }else{
          _this.alertLoading = false
        }
      }).catch(()=>{
        _this.alertLoading = false
      })
    },
    getColor(){//获取下载按钮的颜色
      this.fileName=[{isBoolean:false},{isBoolean:false},{isBoolean:false},{isBoolean:false},{isBoolean:false},{isBoolean:false}],
 
        this.fileName.forEach((item,index)=>{
          let monthVal = this.monthValue

          if(monthVal.getDate()!==1){
            let clickMonth = this.monthValue
              clickMonth.setDate(1)
              monthVal = clickMonth
          }

          let weekStart = monthVal.getDay()
          let y = monthVal.getFullYear()
          let m = monthVal.getMonth()+1
          if(weekStart === 0){
            weekStart = 7
          }
          let dd = monthVal.getDate()-weekStart+1
          let d = dd+index*7
               
            if(d<1){
              if(m==2 || m==4 || m==6 || m==8 || m==9 || m==11 || m==1){
                d = d+31
              }else if(m==5 || m==7 || m==10 || m==12){
                d = d+30
              }else if(m==3){
                let Leap = ''+y/4
                if(Leap.length>3){
                  d = d+28
                }else{
                  d = d+29
                }
              }
              m = m-1
              if(m<1){
                m = 12
                y = y-1
              }
            }

            let Leap = ''+y/4
            if(Leap.length>3){//闰年
              if(m==2){
                if(d>29){
                  m = m+1
                  d=d-29
                }
              }else if(m==4 || m==6 || m==9 || m==11){
                if(d>30){
                  m = m+1
                  d=d-30
                }
              }else{
                if(d>31){
                  m = m+1
                  d=d-31
                }
              }
            }else{
              if(m==2){
                if(d>28){
                  m = m+1
                  d=d-28
                }
              }else if(m==4 || m==6 || m==9 || m==11){
                if(d>30){
                  m = m+1
                  d=d-30
                }
              }else{
                if(d>31){
                  m = m+1
                  d=d-31
                }
              }
            }

            let dataTime = y +'/'+ m +'/'+ d
            var ao = new Date(dataTime) 
            
            if(ao<new Date()){
              item.isBoolean = true
            }

        })
    }
  },
  filters: {//转换时间发方法
    formatDate (time) {
      if (time === null || time === '') {
        return ''
      }
      var date = new Date(time)
      return formatDate(date, 'yyyy/MM/dd')
    },
    formatTime (time) {
      if (time === null || time === '') {
        return ''
      }
      var date = new Date(time)
      return formatDate(date, ' hh:mm')
    }
  }
}
</script>
<style scoped>
.EquipmentUtilizationRate{
   min-width: 1365px!important;/*最小宽度 */
}
.mainWrao{
  height: 100%;
  width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
}
.recordTitle{
  padding: 20px 25px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
}
.recordTitle h1{
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
  display: inline-block;
}
.seach{
  padding: 15px 10px;
}
.seach button{
  float: right;
}
#chartWrap .chartTitle{
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}
.recordTitle .machineSeach{
  float: right;
  display:flex;
  align-items: center;
}
.machineSeach .everyWorkShop{
    border: 1px solid #409EFF;
    border-radius: 10px;
    padding: 2px 10px;
    color:#409EFF;
    margin-right:10px;
    cursor: pointer;
}
.machineSeach .activeWorkShop{
  background:#409EFF;
  color:#fff;
}
/* 我的样式 */
.flexes{
    display: flex;
}
.scroll{
  overflow: auto;
}
.FailureTime-body{
    width: 94%;
    margin: 5px auto 0;
}
.FailureTime-th{
    color: rgba(0, 0, 0, 0.85);
}
.FailureTime-th-left{
    border-right:1px solid rgba(166, 166, 166, 1);
}
.FailureTime-th-bottom{
    border-top:1px solid rgba(166, 166, 166, 1);
    font-size: 12px;
	line-height: 150%;
}
.FailureTime-th-bottom div{
    padding: 10px 0;
    white-space:nowrap;
}
.FailureTime-td-left{
  border-top:1px solid rgba(166, 166, 166, 1);
  font-size: 12px;
  line-height: 150%;
  padding: 8px 0;
}
.FailureTime-left div{
    width: 80px;
    text-align: center;
}
.FailureTime-th-right{
    border-left:1px solid rgba(166, 166, 166, 1);
}
.scroll li:nth-child(1) .FailureTime-th-right{
  border:none;
}
.empty{
  color: #fff;
}
.th-title{
    text-align: center;
    font-size: 16px;
    line-height: 150%;
    font-weight: bold;
}
.FailureTime-td-right{
  border-top:1px solid rgba(166, 166, 166, 1);
  padding: 8px 0;
}
.FailureTime-right div{
    width: 80px;
    text-align: center;
    font-size: 12px;
    line-height: 150%;
}
.FailureTime-right div:nth-child(3){
  width: 120px;
}
.FailureTime-right div:nth-child(4){
  width: 140px;
}
.downBotton{
  margin: 15px 0;
  float: right;
}
.widthOne{
  width: 100%;
}
.widthTwo{
  width: 100%;
}

.footer{
  width: 94%;
  margin: 30px auto;
  height: 113px;
  background: #fff;
}
.footer-el{
  padding-top: 40px;
  width: 410px;
  margin: 0 auto;
}

/* ----------弹框----------- */
.ElasticTitle{
  text-align: center;
  font-size: 22px;
  padding-bottom: 20px;
}
.myBody{
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
}

.my .myLeft{
  width: 82%;
  height: 100%;
  border:1px solid #efefef;
  position: relative;
}
.yearMonths{
  width: 118px;
  position: absolute;
  right: 230px;
  top:11px;
  height: 28px;
  border:1px solid #DCDFE6;
  border-radius: 3px;
  overflow: hidden;
}
.yearMonths-right{
  right: 310px;
}
.nextMonth{
  /* display: none; */
  position: absolute;
  top: 12px;
  right: 20px;
  z-index: 10;
  border:1px solid #DCDFE6;
  border-left: none;
  color: #C0C4CC;
  font-size: 12px;
  line-height: 12px;
  /* height: 26px; */
  /* width: 66px; */
  padding: 7px 15px;
  text-align: center;
  border-radius: 0 3px 3px 0;
  background-color: #F5F7FA;
  cursor:no-drop;/* 鼠标悬浮禁用 */
  user-select: none;
  font-family: "Arial";
}
.yearMonths .yearMonths-box{
  position: absolute;
  top: -6px;
  left:-1px;
}

.my .myRight{
  width: 16%;
  height: 100;
  background-color: rgba(236, 235, 235, 1);
}
.myRight .rightTitle{
  color: rgba(80, 80, 80, 1);
  font:bold 16px/54px 'Microsoft YaHei';
  text-align: center;
}
.myRight .rightBody{
  padding-top: 55px;
}
.rightItem{
  display: flex;
  padding: 18px 0;
}
.rightItem .rightLine{
  width: 53px;
  height: 1px;
  background-color: rgba(153, 153, 153, 1);
  margin: 24px 5px 25px 0;
}
.rightItem .rightCircular{
  width: 24px;
  height: 24px;
  padding: 10px 13px 16px;
  border-radius: 50%;
  background-color: rgba(15, 157, 88, 1);
  text-align: center;
  cursor: pointer;
  position: relative;
}
.rightItem .rightCircularColor{
  background-color: rgba(153, 153, 153, 1);
}
.rightItem .rightCircular .BriefcaseDownload{
  color: #fff;
  font-size: 24px;
}
.rightCircular:hover .fileName{
  display: block;
}
.fileName{
  display: none;
  position: absolute;
  right: 30px;
  width: 240px;
  background-color: #fff;
  text-align: center;
  word-wrap:break-word;
  font-size: 12px;
  line-height: 180%;
  color: rgba(80, 80, 80, 1);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1785714285714286);
  user-select: none;
  z-index: 1;
}

/* element-ui样式 */
.el-date-editor.el-input, .el-date-editor.el-input__inner{
  width: 120px;
}
</style>

